import React, { useState, useRef, useCallback } from 'react';

/**
 * Infobulle visible au survol ou au clic (ne dépend pas de bootstrap-icons ni de title natif).
 */
export default function BrokenTileInfoHint({ text, placement = 'top' }) {
  const [visible, setVisible] = useState(false);
  const hideTimer = useRef(null);

  const show = useCallback(() => {
    if (hideTimer.current) {
      clearTimeout(hideTimer.current);
      hideTimer.current = null;
    }
    setVisible(true);
  }, []);

  const hide = useCallback(() => {
    hideTimer.current = setTimeout(() => setVisible(false), 120);
  }, []);

  const placementClass =
    placement === 'right'
      ? 'broken-tile-hint--right'
      : placement === 'bottom'
        ? 'broken-tile-hint--bottom'
        : '';

  return (
    <span
      className={`broken-tile-hint ${placementClass}`}
      onMouseEnter={show}
      onMouseLeave={hide}
    >
      <button
        type="button"
        className="broken-tile-hint__btn"
        aria-label="Voir l'explication"
        aria-expanded={visible}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setVisible((v) => !v);
        }}
        onFocus={show}
        onBlur={hide}
      >
        i
      </button>
      {visible && text && (
        <span className="broken-tile-hint__bubble" role="tooltip">
          {text}
        </span>
      )}
    </span>
  );
}
